// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyCkwBv1-VGQvSZ6tWKXiLZileqN1IKHJlg",
  authDomain: "e-clone-ad845.firebaseapp.com",
  projectId: "e-clone-ad845",
  storageBucket: "e-clone-ad845.appspot.com",
  messagingSenderId: "172592348295",
  appId: "1:172592348295:web:5318d046a1238494e3cc22",
  measurementId: "G-726BFX26X5"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db= firebaseApp.firestore();

export {auth, db};